<template>
  <table v-if="data.td.length > 0 && Array.isArray(data.td)" class="table table-bordered"
         style="margin-bottom: 0">
    <thead>
    <tr>
      <th v-for="(value, keyName) in data.td[0]" :key="keyName+value" class="vgt-left-align"
          style="min-width: auto; width: auto;"><span>{{ keyName }}+1</span></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="row in data.td">
      <td v-for="record in row" class="vgt-left-align"><span>{{ renderRecord(record) }}</span></td>
    </tr>
    </tbody>
  </table>
  <div v-else>
    Preview not available.
  </div>
</template>

<script>
import {isJSON} from "../../utils/functions";
import {URL, BUCKET_URL} from '@/http-common';

export default {
  name: "StandardTable",
  props: ['data'],
  methods: {
    renderRecord(records) {
      if (isJSON(records) && Array.isArray(JSON.parse(records))) {
        return JSON.parse(records).map(record => {
          return record.name ? record.name : record
        }).join(', ')
      }

      return records
    }
  },
  computed: {
    token: function () {
      return localStorage.getItem('id_token');
    },
    url: function () {
      return URL;
    }
  }
}
</script>



// WEBPACK FOOTER //
// StandardTable.vue?3531a06e